import { pxToRem, themeGet } from '@pocketlaw/tetris';
import { motion } from 'motion/react';
import styled from 'styled-components';
export const StickyContainer = styled(motion.div).attrs((p) => ({
    animate: {
        opacity: p.$show ? 1 : 0,
        y: p.$show ? 0 : pxToRem(8),
        scale: p.$show ? 1 : 0.9,
        display: p.$show ? 'block' : 'none',
    },
    initial: false,
})) `
  pointer-events: none;
  position: absolute;
  overflow: hidden;
  left: 0;
  right: 0;
  bottom: ${themeGet('spacing.2xl')};
`;
export const InnerContainer = styled.div `
  pointer-events: all;
  display: flex;
  margin: 0 auto;
  width: fit-content;
  align-items: center;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.lg')};
  border-radius: ${themeGet('borderRadius.lg')};
  background-color: ${themeGet('colors.gray.1000')};
  box-shadow: ${themeGet('dropShadow.300')};
`;
